var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _circle, _circle2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.43 261.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.56,207.32v-6.56c0-3-1.46-4.47-4.38-4.47H14.63c-2.85,0-4.27,1.5-4.27,4.47v12.38A3.64,3.64,0,0,0,11.2,216a20.79,20.79,0,0,0,2.7,1.87l9.46,5.1a44.57,44.57,0,0,1,4.43,2.75,7.05,7.05,0,0,1,2,2.4c.48.93.73,2.72.73,5.35v15.91q0,12.59-12.07,12.59H12.34q-12,0-12-13.73v-3.74h10v4.05c0,2.91,1.5,4.37,4.47,4.37H16.6q4,0,4-4.37V235.81a3.65,3.65,0,0,0-.84-2.81,21.84,21.84,0,0,0-2.7-1.87l-9.47-5.3A29.94,29.94,0,0,1,3,223a6.41,6.41,0,0,1-2-3,14.81,14.81,0,0,1-.62-4.73V200q0-12.79,12-12.8h6.24q12,0,12,12.8v7.28Z",
    fill: "#37abc8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.57,261.92H38.85V187.24h10v65.63H62.57Z",
    fill: "#37abc8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.83,261.92q-12.06,0-12.07-12.69V200q0-12.79,12-12.8H89.3q12,0,12,12.8v49.19q0,12.69-12.06,12.69Zm2.39-9.05h5.1q3.95,0,4-4.37V200.66q0-4.36-4.48-4.37H82.12c-2.92,0-4.37,1.46-4.37,4.37V248.5Q77.75,252.87,82.22,252.87Z",
    fill: "#37abc8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.3,187.24l-11,74.68H140.45l-6.13-43.27-6,43.27H117.47l-11-74.68h9.88l7.07,56,7.07-56h7.8l7.08,56,7.07-56Z",
    fill: "#37abc8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.38,41.91h-.06a16.45,16.45,0,0,0-32.66,2.79,15.93,15.93,0,0,0,.3,2.94h0v0c0,.19.07.39.11.58,13.79,70-19.34,74.12-56.89,78.81C9,133.6,0,160,0,160s0,9.41,9.41,9.41h94.13S160,169.43,160,113C160,80,155.09,74.86,150.38,41.91Z",
    fill: "#795548"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134.58,
    y: 14.12,
    width: 36.76,
    height: 9.41,
    transform: "matrix(0.64, -0.77, 0.77, 0.64, 40.58, 124.28)",
    fill: "#795548"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.6,
    y: 0.94,
    width: 9.41,
    height: 40.49,
    transform: "translate(9.17 70.97) rotate(-35.54)",
    fill: "#795548"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160.02,
    cy: 9.41,
    r: 9.41,
    fill: "#5d4037"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.25,
    cy: 9.41,
    r: 9.41,
    fill: "#5d4037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.63,43.54a9.85,9.85,0,0,0-9.44-5.9,9.42,9.42,0,0,0-9.41,9.41c0,1.53,11.7,61.32,0,84.72C117.66,160,98.84,160,89.42,160H0s0,9.41,9.41,9.41h94.13s61.19,4.71,61.19-51.77C164.73,85.29,155.31,80,150.63,43.54Z",
    fill: "#bcaaa4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.19,70.39a2.27,2.27,0,0,1-.17-.31c3,49.09-26.67,52.85-59.84,57a123.3,123.3,0,0,0-29.44,7.11c-2.06,1.43-3.51,2.09-4.11,1.69h0q-2.59,1.17-4.92,2.38l-.1.05c-1.51.8-2.94,1.6-4.25,2.42h0a70.36,70.36,0,0,0,29.74,13.39c1.36.26,3,.49,4.74.73.51.06,1,.15,1.52.19a88.29,88.29,0,0,0,10.14.6,75.49,75.49,0,0,0,9-.52l2-.24,1.72-1a75.71,75.71,0,0,0,14.6-11.31,63.51,63.51,0,0,0,9.59-12.43c14.09-3.34,29.8-11.71,30.35-28.87C131.78,100.31,133.25,86.87,121.19,70.39Z",
    fill: "#4e342e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,84.81a61.19,61.19,0,1,1,122.37,0c0,.67.88,8.82-.89,16.18-5.29,23.82-32.06,21.47-32.06,21.47S74.71,146,61.18,146A61.18,61.18,0,0,1,0,84.81Z",
    fill: "#ff9800"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.56,52c1-.07,1.93-.15,2.92-.15a37.65,37.65,0,0,1,7.17.7A66.55,66.55,0,0,0,69,24.18a61.45,61.45,0,0,0-7.85-.56c-.54,0-1.07.08-1.61.09C60.4,36.33,55.76,47.49,53.56,52Z",
    fill: "#ffb74d"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.85,55.77a36.75,36.75,0,0,1,9.91-3.27c.76-7.87.52-17.77-3.19-27.06a61.72,61.72,0,0,0-8.92,2.95C41.58,37.8,41,48.48,39.85,55.77Z",
    fill: "#ffb74d"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1,58.72c3.82-6,9.35-16.3,11.32-28.16a61.49,61.49,0,0,0-8.94-3.79c-1.35,11.54-7.18,22-10.74,27.54A37.71,37.71,0,0,1,78.1,58.72Z",
    fill: "#ffb74d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.23,88.74l2.65,1.76c0-.33-.05-.66-.05-1a37.92,37.92,0,0,1,1.23-9.41A37.17,37.17,0,0,0,.7,76,61,61,0,0,0,0,84.81c0,.22,0,.44,0,.66A26.84,26.84,0,0,1,16.23,88.74Z",
    fill: "#ffb74d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,68.61l2.6,3.9,1-.69a37.75,37.75,0,0,1,14-14.63C36,50.33,32,42,25.4,35.21a61,61,0,0,0-7.17,6.15c6.6,6.57,10,15,10,19.91v3.28l-.79-1.18A40,40,0,0,0,10.76,50.26,59.74,59.74,0,0,0,6,58.47,30.25,30.25,0,0,1,19.63,68.61Z",
    fill: "#ffb74d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1,93.87l-1.76.59a38.68,38.68,0,0,0-14.27,9.41,60.51,60.51,0,0,0,4.17,9.79,29.33,29.33,0,0,1,13.09-10.28l1.05-.35A36.71,36.71,0,0,1,19.1,93.87Z",
    fill: "#ffb74d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.56,80.37l3.12,8.88c6.85-2.39,18.06-9.89,23.62-23.5A61.11,61.11,0,0,0,113,52.42,33.3,33.3,0,0,1,92.56,80.37Z",
    fill: "#ffb74d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.82,70.19c.71-.35,14.4-7.43,19.51-26.57a60.43,60.43,0,0,0-8.09-7.41c-2.8,18.57-15,25.2-15.65,25.57l-4.19,2.1Z",
    fill: "#ffb74d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9,113a48.22,48.22,0,0,0,27.27-16,65,65,0,0,0,.2-12.22,59.78,59.78,0,0,0-.53-7.61c-5.28,22.15-27.5,26.32-28.5,26.5l-3.08,10Z",
    fill: "#ffb74d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.15,60a43.87,43.87,0,0,0-62,0,36.09,36.09,0,0,0,0,51,29.81,29.81,0,0,0,42.1,0,24.75,24.75,0,0,0,0-35,20.74,20.74,0,0,0-29.34,0,17.55,17.55,0,0,0,0,24.8,15,15,0,0,0,21.18,0,4.71,4.71,0,0,0-6.66-6.65,5.57,5.57,0,0,1-7.87,0,8.15,8.15,0,0,1,0-11.49,11.59,11.59,0,0,1,16,0,15.32,15.32,0,0,1,0,21.69,20.36,20.36,0,0,1-28.78,0,26.65,26.65,0,0,1,0-37.65,34.45,34.45,0,0,1,48.72,0,44.28,44.28,0,0,1,0,62.56,56.09,56.09,0,0,1-29.38,15.55,79.06,79.06,0,0,0,23.25,1,66.34,66.34,0,0,0,12.79-9.91A53.73,53.73,0,0,0,85.15,60Z",
    fill: "#ce630b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlow);
export default __webpack_public_path__ + "static/media/slow.defb61dd8d2b85984340988b9faaefc1.svg";
export { ForwardRef as ReactComponent };